import React, { useState, useEffect, useRef } from "react";
import { getAreapCook } from "../../../../utils/params";
import { socketon } from "../../../../utils/socket";

function Stack() {

  const [turno0, setTurno0] = useState('---');
  const [turno1, setTurno1] = useState('---');
  const [turno2, setTurno2] = useState('---');
  const [turno3, setTurno3] = useState('---');
  const [turno4, setTurno4] = useState('---');
  
  const [modulo0, setModulo0] = useState('');
  const [modulo1, setModulo1] = useState('');
  const [modulo2, setModulo2] = useState('');
  const [modulo3, setModulo3] = useState('');
  const [modulo4, setModulo4] = useState('');
  const [animar, setAnimar] = useState(false);

  const [turno, setTurno] = useState(0);

  let Consecutivo = useRef('---');
  let UltTurno = useRef('---');
  let Modulo = useRef('---');
  let ContTurno = useRef(0);
  const animTimeoutRef = useRef(null);

//----------------------------------------------------------------------------------------------------------------------
  const actualizaTurnos = () =>{
    setTurno4(turno3);
    setModulo4(modulo3)

    setTurno3(turno2);
    setModulo3(modulo2)

    setTurno2(turno1);
    setModulo2(modulo1);

    setTurno1(turno0);
    setModulo1(modulo0);

    setTurno0(Consecutivo.current);
    setModulo0(Modulo.current);
    UltTurno.current= Consecutivo.current;
  }

  const ActualizaSocket =() =>{
    let AreaId = getAreapCook();
    socketon.on("ActualizaTurno", (message, sender) => {
      if (message) {
        if (message[0].AreaId.toString() === AreaId)
        {
          if (animTimeoutRef.current) clearTimeout(animTimeoutRef.current);
          setAnimar(false); // reinicia el estado antes
          setTimeout(() => 
            {
               setAnimar(true); // dispara animación visible
            }, 10); // pequeño delay para asegurar el reinicio

           Consecutivo.current = message[0].Prefijo + message[0].Consecutivo;
           if (Consecutivo.current !== UltTurno.current)
           {
              Modulo.current = `${message[0].CodigoMod}`;
              ContTurno.current += 1;
              setTurno(ContTurno.current);
           } 
           animTimeoutRef.current = setTimeout(() => setAnimar(false), 20000);
        }
      }
    });
  }
 
  useEffect(() => {
    ActualizaSocket();
   }, []);
  
   useEffect(() => {
    if (turno > 0)
    {
      actualizaTurnos();
    }
   }, [turno]);
   
  return (
    <div className="flex flex-row w-full h-[12rem] items-center justify-center space-x-4">
      <div className="flex flex-col w-[13rem] h-[7.2rem] bg-light border border-gray-500 rounded-lg shadow-lg shadow-default">
        <span className="flex w-full h-[7.2rem] text-[2.8rem] text-center items-center justify-center">{turno2}</span>
        <span className="flex w-full h-[3.8rem] bg-black text-center items-center justify-center text-red-600 text-[2.8rem] rounded-b-lg">{modulo2}</span>
      </div>
      <div className="flex flex-col w-[13rem] h-[7.2rem] text-center items-center justify-center bg-light border border-gray-500 rounded-lg shadow-lg shadow-default">
        <span className="flex w-full h-[7.2rem] text-[2.8rem] text-center items-center justify-center">{turno1}</span>
        <span className="flex w-full h-[3.8rem] bg-black text-center items-center justify-center text-red-600 text-[2.8rem] rounded-b-lg">{modulo1}</span>
      </div>
      
      <div className={`flex flex-col w-[19rem] h-[12rem] mt-2 text-center items-center justify-center bg-light border border-gray-500 rounded-lg shadow-lg shadow-default ping-visible  ${animar ? "ping-visible borde-parpadeante animate-pulse border-red-500" : ""} transition`}>
        <div className="flex w-full h-[8rem] text-[4.65rem] text-center items-center justify-center text-red-700 font-semibold"><span className="animacion">{turno0}</span></div>
        <div className="flex w-full h-[4rem] bg-black text-center items-center justify-center text-red-600 text-[3rem] font-semibold rounded-b-lg"><span className="animacion">{modulo0}</span></div>
      </div>

      <div className="flex flex-col w-[13rem] h-[7.2rem] text-center items-center justify-center bg-light border border-gray-500 rounded-lg shadow-lg shadow-default">
        <span className="flex w-full h-[7.2rem] text-[2.8rem] text-center items-center justify-center">{turno3}</span>
        <span className="flex w-full h-[3.8rem] bg-black text-center items-center justify-center text-red-600 text-[2.8rem] rounded-b-lg">{modulo3}</span>
      </div>
      <div className="flex flex-col w-[13rem] h-[7.2rem] text-center items-center justify-center bg-light border border-gray-500 rounded-lg shadow-lg shadow-default">
        <span className="flex w-full h-[7.2rem] text-[2.8rem] text-center items-center justify-center">{turno4}</span>
        <span className="flex w-full h-[3.8rem] bg-black text-center items-center justify-center text-red-600 text-[2.8rem] rounded-b-lg">{modulo4}</span>
      </div>
      
      
    </div>
  );
}

export default Stack;
